import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../../../../endPoints/endPoints";
import { IFlight, IFlightFull, IFlightNew, IFlightPager } from "./IFlight";

export const flightApi = createApi({
  reducerPath: "flight",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.WORKLIGHTS,
  }),
  tagTypes: ["flights", "flight"],
  endpoints: (builder) => ({
    getFilteredFlights: builder.query<IFlightPager, string>({
      query(searchParams) {
        return {
          url: `/pagination?${searchParams}`,
        };
      },
      providesTags: ["flights"],
    }),
    getAllFlights: builder.query<(IFlight)[], void>({
      query() {
        return {
          url: "",
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["flights"],
    }),
    addFlight: builder.mutation<any, IFlightNew>({
      query(body) {
        return {
          url: "",
          method: "POST",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["flights"],
    }),
    getFlight: builder.query<IFlight, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["flight"],
      transformResponse: (response: IFlightFull) => {
        return {
          id: response.id,
          airbase_id: response.airbase.id,
          airbase_name: response.airbase.name,
          contract_id: response.contract.id,
          contract_name: response.contract.name,
          number: response.number,
          application_date: response.application_date,
          date_start: response.date_start,
          date_end: response.date_end,
          duration: response.duration,
          transport_id: response.transport.id,
          transport_name: response.transport.name,
          transport_number: response.transport.number,
          transport_type: response.transport.avia_model_id,
          works: response.contract.works
        }
      }
    }),
    editFlight: builder.mutation<IFlightNew & {id: number}, IFlightNew & {id: number}>({
      query({ id, ...body }) {
        return {
          url: `/${id}`,
          method: "PUT",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["flights", "flight"],
    }),
    deleteFlight: builder.mutation<string, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
          credentials: "include",
        };
      },
      invalidatesTags: ["flights"],
    }),
  }),
});

export const {
  useAddFlightMutation,
  useDeleteFlightMutation,
  useGetAllFlightsQuery,
  useGetFilteredFlightsQuery,
  useEditFlightMutation,
  useGetFlightQuery
} = flightApi;
